import type { QueueItem } from "@/api/migrationQueue";
export function QueueHistoryLinks({ item }: { item: QueueItem }) {
  return (
    <div className="mt-2 flex flex-wrap gap-3">
      {item.pr_url && /^https:\/\/github\.com\//.test(item.pr_url) && (
        <a
          className="text-indigo-300 underline"
          href={item.pr_url}
          target="_blank"
          rel="noreferrer"
        >
          PR #{item.pr_url.split("/").pop()}
        </a>
      )}
      {item.task_id && (
        <a
          className="text-indigo-300 underline"
          href={`https://hub.jumpstart.co.il/tasks/table?task=${
            encodeURIComponent(item.task_id)
          }`}
          target="_blank"
          rel="noreferrer"
        >
          {item.task_title ? `משימה: ${item.task_title}` : "למשימה המקושרת"}
        </a>
      )}
    </div>
  );
}
